import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";


const positionApi = createApi({
    reducerPath: "base/position",
    baseQuery: axiosBaseQuery,
    tagTypes: ["positionList"],
    endpoints: (builder) =>({
        positionFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['positionList'],
            query: (query = '') => ({
                url: "/base/position" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        positionCreate: builder.mutation({
            invalidatesTags: ['positionList'],
            query: (data)=>({url: "/base/position", method: "POST", data})
        }),
        positionUpdate: builder.mutation({
            invalidatesTags: ['positionList'],
            query: (data)=>({url: "/base/position/"+data.id, method: "PUT", data})
        }),
        positionDelete: builder.mutation({
            invalidatesTags: ['positionList'],
            query: (id)=>({url: "/base/position/"+id, method: "DELETE"})
        }),
    })
})

export const { usePositionFindAllQuery, usePositionCreateMutation, usePositionUpdateMutation, usePositionDeleteMutation } = positionApi;
export {positionApi};
